import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { TOURNEY_HEADER_EMPHASIS_TEXT_COLOR, TOURNEY_HEADER_TEXT_COLOR } from '../../../styles/colors';
const TEXT_CSS = css `
  filter: drop-shadow(1px 1px 0 black);
`;
export const MttNumTablesDisplayContainer = ({ numMttTables }) => {
    const containerCss = useMemo(() => css `
      color: ${numMttTables === 1 ? TOURNEY_HEADER_EMPHASIS_TEXT_COLOR : TOURNEY_HEADER_TEXT_COLOR};
      white-space: nowrap;
      background-color: rgba(0, 0, 0, 0.4);
      padding: 2px 2px 2px 8px;
      border-radius: 0 0 0 10px;
      font-size: 13px;
      font-weight: ${numMttTables === 1 ? 'bold' : 'inherit'};
    `, [numMttTables]);
    return (_jsx("div", { css: containerCss, children: _jsx("span", { css: TEXT_CSS, children: numMttTables === 1 ? 'Final Table' : `${numMttTables} Tables` }) }));
};
